declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export function initAnalytics() {
  if (!GA_ID || window.gtag) return;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_ID, { send_page_view: false });
}

export function pageView(path: string) {
  window.gtag?.("event", "page_view", { page_path: path, page_location: window.location.href, page_title: document.title });
}

// Conversion events: call_click, generate_lead, quote_cta_click. Mark call_click + generate_lead as key events in GA4.
export function track(event: string, params: Record<string, unknown> = {}) {
  const payload = { ...params, page_path: window.location.pathname };
  window.gtag?.("event", event, payload);
  if (!window.gtag) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...payload });
  }
}

export function captureUtm() {
  const p = new URLSearchParams(window.location.search);
  const utm: Record<string, string> = {};
  ["utm_source", "utm_medium", "utm_campaign", "utm_term", "gclid"].forEach((k) => {
    const v = p.get(k);
    if (v) utm[k] = v;
  });
  if (Object.keys(utm).length) sessionStorage.setItem("cif_utm", JSON.stringify(utm));
  if (!sessionStorage.getItem("cif_landing")) sessionStorage.setItem("cif_landing", window.location.pathname);
}

export function getUtm(): Record<string, string> {
  const utm = JSON.parse(sessionStorage.getItem("cif_utm") || "{}");
  const landing = sessionStorage.getItem("cif_landing");
  return landing ? { ...utm, landing_page: landing } : utm;
}
